import { useEffect } from 'react';
import { FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { GENERAL } from '../../../../utils/constants';
import { TransmissionDownloadProps } from './transmission-download';
const { dashboard, common } = en;

export function PostTransmissionDownloadList(props: TransmissionDownloadProps) {
    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    const { formsTobeTaken = [] } = props.location.state || {};

    const handleSubmit = () => {
        props.history.push('/portal/nct/transmission-download-otp', props.location.state);
    };

    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => props.history.push('/portal/nct/transmission-download')}>
                    <img src="/images/left-arrow-black.svg" alt="" />
                </a>
                {dashboard.TransmissionRequest.TransmissionRequestHeading}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer transmission-request transmission-download-list">
                <div className="curved-bg-content-inner">
                    <div className="transmission-download-content">
                        <div className="transmission-download-content-top post-transmission-list">
                            <img
                                className="transmission-download-character"
                                src="/images/transmission-download-character.png"
                                alt=""
                            />
                            <p>{dashboard.TransmissionRequest.postLogin.mainInfo}</p>
                            <img src="/images/transmission-download-building.png" alt="" />
                        </div>
                        <div className="transmission-download-content-bottom">
                            {formsTobeTaken.map((form, index) => (
                                <div key={index} className="transmission-download-list-documents">
                                    <div className="transmission-download-list-number">
                                        <p>
                                            <img src="/images/document-bg.svg" alt="" />
                                            <span>{index + 1}</span>
                                        </p>
                                    </div>
                                    <div className="transmission-download-list-txt">
                                        <h5>{form.description || form.title}</h5>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <FaqLink section={GENERAL} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={handleSubmit}
                            label={dashboard.TransmissionRequest.downloadList.doneBtn}
                            className="customBtn"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
